import { Box, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const DataGridEmpty = () => {
  const { t } = useTranslation(['common']);
  return (
    <Box
      sx={{
        height: 180, // DataGriden har minHeight på 250 för att denna ska visas om no rows efter MUI-uppdatering /Sofie 2023-02-08
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant='h5' align='center' sx={{ color: 'grey.500' }} gutterBottom>
        {t('common:statusMessages.noResult')}
      </Typography>
      <Typography align='center' sx={{ color: 'grey.500', m: 1 }}>
        <InfoOutlined sx={{ fontSize: '4rem' }} aria-hidden />
      </Typography>
    </Box>
  );
};

export default DataGridEmpty;
